module.exports = __webpack_public_path__ + "img/DE00415.0b148070.png";